import { useAuthenticationStatus } from 'shared/hooks/user';
import { useBalances } from 'shared/hooks/balance';
import { Idea } from '../../../../types';

export const useSubmitSectionValues = (idea: Idea) => {
  const isAuthenticated = useAuthenticationStatus();

  const { balances } = useBalances();

  const maxEnterAmount =
    idea.properties.__typename === 'Investment_BuyAndHoldIdeaProperties' &&
    idea.properties.maxEnterAmount
      ? idea.properties.maxEnterAmount.value
      : Number.MAX_VALUE;

  const balance = balances[idea.enterAmount.currency];

  return {
    isAuthenticated,
    balance,
    min: idea.enterAmount,
    max: {
      value: Math.min(maxEnterAmount, balance.value),
      currency: balance.currency,
    },
  };
};
